module.exports = __webpack_public_path__ + "img/apply_bg.86be2f75.png";